import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import { useTranslation } from 'react-i18next';

import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';

const Delete: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  return (
    <EditorIconButton
      featureId="node:gif:delete"
      icon={EditorDelete}
      onClick={() => editor.chain().focus().daDeviationDelete().run()}
      tooltipHoverDelay={TOOLTIP_HOVER_DELAY}
      tooltipText={t('ext.gif.button.delete')}
      aria-label={t('ext.gif.button.delete')}
    />
  );
};
Delete.displayName = 'Delete';

export default Delete;
